<template>
  <div class="settings__bottom-content">
    <div class="trust-list">
      <div v-if="$store.state.org.userTrusts.length == 0">Loading your Trusts...</div>
      <a class="trust-link" v-for="(trust, index) in trustNavList" :key="index" :href="getTrustUrl(trust)">
        <p>
          {{ trust.name }}
        </p>
      </a>
      <button class="viewIndexBtn" @click="viewIndex">View Full Index</button>
    </div>
    <div class="wallet-details">
      <div class="wallet-details__name">
        <div class="walletInitial">{{ $store.state.walletConnect.user.displayAddress }}</div>
        <transition name="fadeQuick" mode="out-in">
          <div v-if="initialShowCondition" class="walletInitial uppercase">{{ $store.state.walletConnect.user.displayAddress.charAt(0) }}</div>
        </transition>
      </div>
      <button class="primary" @click="disconnectWallet" v-if="$store.state.walletConnect.user.displayAddress">Disconnect</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SettingsTop',
  components: {
  },
  data() {
    return {
    }
  },
  props: ['initialShowCondition'],
  computed: {
    trustNavList(){
      let trusts = this.$store.state.org.userTrusts;
      return trusts.sort((a, b) => a.name.localeCompare(b.name)).filter(t => t.name != this.$store.state.org.name);
    },
  },
  methods: {
    disconnectWallet(){
      this.$store.dispatch('disconnectWallet')
    },
    getTrustUrl(trust){
      let trustUrl = '/' + trust.shorthand;
      return trustUrl;
    },
    viewIndex(){
      this.$emit('setNowViewing', 'Index');
    }
  },
  mounted () {
  },
  watch: {
  }
}
</script>
<style>
.viewIndexBtn {
  margin-top: 12px;
  margin-bottom: 8px;
  width: calc(100% - 15px);
}
</style>
